import emojiRegexp from 'emoji-regex';

export const unicodeEmojiRegexp = emojiRegexp();
